/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetTime200Response,
} from '../models/index';
import {
    GetTime200ResponseFromJSON,
    GetTime200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class ConfigApi extends runtime.BaseAPI {

    /**
     */
    async getTimeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTime200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/time`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTime200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTime(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTime200Response> {
        const response = await this.getTimeRaw(initOverrides);
        return await response.value();
    }

}
